import { useState, useEffect, useRef } from "react";
import { getSolicitarTurno } from "../../services/servicios";
import {setTurnoPendiente, setTurnoAtendido, getTurnoxItemId} from "../../services/turno";
import Icon from "../../Icons/general/Icon";
import { ErrorContext } from "../../utils/context/error";
import PropTypes from 'prop-types';
import Modal from "../modal";

function LlamarModal({ show, areaId, servicioId, handleshow }) 
{
   const [Turno, setTurno] = useState([]);
   const [tbMedicos, setMedicos] = useState([]);
   const { setShowToast, setOpciones } = ErrorContext();
   const [ desbloquea, setDesbloquea] = useState(true);
   const [profesional, setProfesional] = useState(0);
   const [consult, setConsult] = useState("NO");
   
   const [validar, setValidar] = useState(false);
   const timer = useRef(null);
   
//------------- Metodo que se ejecuta y aparta el turno ----------------------------------------------------------------
   const fillTurno = async () => 
    {
      setTurno([]);
      setDesbloquea(true);
      const response = await getSolicitarTurno(areaId, servicioId);
      if (response)
        {
           if (response.status === 200) 
            {
               setTurno(response.data.data[0]);
               setMedicos(response.data.Medicos);
               setConsult(response.data.data[0].Consult);
               setDesbloquea(false);
            } 
           else
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        } 
    };
  
//--------------- Boton Pendientes -------------------------------------------------------------------------------------
   const handlePendiente = async () => 
    {
      setValidar(false);
       const TurnoId = Turno.TurnoId;
       const ItemId = Turno.ItemId;
       const PeriodoId = Turno.PeriodoId;
       setDesbloquea(true);   
       const response = await setTurnoPendiente(TurnoId, ItemId, PeriodoId);
       if (response) handleshow(false);
       setDesbloquea(false);
    };
  
//--------------- Boton atender ----------------------------------------------------------------------------------------
   const handleAtender = async () => 
    {
      setValidar(false);
      setShowToast(false);
       const TurnoId = Turno.TurnoId;
       const ItemId = Turno.ItemId;
       const PeriodoId = Turno.PeriodoId;
       setDesbloquea(true);
             
       if (profesional > 0 || consult !=='SI')
         {
            const response = await setTurnoAtendido(TurnoId, ItemId, PeriodoId, profesional);
            if (response) 
              handleshow(false)
            else
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              requestAnimationFrame(() =>setShowToast(true));
            }
            setDesbloquea(false);
         }
       else
       {
        setValidar(true);
        const Mensaje = 'Se requiere remitir el paciente al profesional que lo va atender'
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               requestAnimationFrame(() =>setShowToast(true));
       }  
       setDesbloquea(false);
    }     
  
//------------- Boton volver a llamar ----------------------------------------------------------------------------------
   const handleLlamar = async () => 
    {
       setValidar(false);
       const TurnoId = Turno.TurnoId;
       const ItemId = Turno.ItemId;
       const PeriodoId = Turno.PeriodoId;

       setDesbloquea(true);

       const response = await getTurnoxItemId(TurnoId, ItemId, PeriodoId);
       if (response) 
        {
           if (response.status === 200) 
            {
               setTurno(response.data.data[0]);
            } 
           else 
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
        }
        setDesbloquea(false);
    };

//----------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
      if (areaId > 0 && show) fillTurno();
    }, [show]);

//----------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
       return () => {
           clearTimeout(timer.current);
        };
    }, []);

//----------------------------------------------------------------------------------------------------------------------
  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={'LLamar Pacientes'} activeclose={false}>
        <div className={`flex flex-col w-full h-full ${desbloquea ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
             <div className="flex flex-col w-full h-full  items-center justify-center mb-5">
                   <div className="flex flex-row w-full h-full items-center justify-center">
                       <span className="text-[3.2rem] font-semibold text-default">
                           {Turno.Prefijo} - {Turno.Consecutivo}
                       </span>
                   </div> 
                   <div className="flex w-full h-full items-center justify-center">   
                      {Turno.TipoDoc !== "" && (
                        <span className="text-[0.8rem] text-gray-500">
                          {Turno.SolicitantId === 0
                            ? `${Turno.TipoDoc} ${Turno.NumeroNit} ${Turno.NombreBen}`
                            : `${Turno.TipoDocAcomp} ${Turno.NumeroNitAcomp} ${Turno.NombreAcomp}`
                          }
                        </span>
                      )}
                   </div> 
                   <div className="flex w-full h-full items-center justify-center  text-gray-500">
                         {Turno.Prioritaria ==="SI" && (
                             <span className="text-gray-800">
                                 PRIORITARIA
                             </span>)
                          }
                   </div>  
             </div>
        
        <div id='footer' className="w-full h-full flex flex-row">
            <div className="w-full h-full flex flex-row space-x-2 items-center justify-center text-center" id="panelllamada">
                <div className="w-[8rem] h-[8rem] rounded-lg items-center justify-center text-center border border-stone-200 shadow-lg shadow-default hover:cursor-pointer hover:bg-body group" 
                     onClick={handleLlamar}>
                     <div className="w-full h-full flex flex-col items-center justify-center text-center ">
                          <Icon
                              svg="repeat"
                              className="w-[4rem] h-[4rem] fill-gray-600 group-hover:fill-sidebar"
                              title="repeat"
                          />
                          <span className="text-gray-700 group-hover:text-sidebar">Repetir</span>
                      </div>
                </div>
                <div className="w-[8rem] h-[8rem] rounded-lg items-center justify-center text-center border border-stone-200 shadow-lg shadow-default hover:cursor-pointer hover:bg-body group" onClick={handleAtender}>
                     <div className="flex flex-col w-full h-full items-center justify-center text-center">
                          <Icon
                             svg="userHeadset"
                             className="w-[4rem] h-[4rem] fill-gray-600 group-hover:fill-sidebar"
                             title="userHeadset"
                          />
                         <span className="text-gray-700 group-hover:text-sidebar">Atender</span>
                     </div>
                </div>
                <div className="w-[8rem] h-[8rem] rounded-lg items-center justify-center text-center border border-stone-200 shadow-lg shadow-default hover:cursor-pointer hover:bg-body group" onClick={handlePendiente}>
                     <div className="flex flex-col w-full h-full items-center justify-center text-center">
                          <Icon
                             svg="phoneSlash"
                             className="w-[4rem] h-[4rem] fill-gray-600 group-hover:fill-sidebar"
                             title="phoneSlash"
                          />
                          <span className="text-gray-700 group-hover:text-sidebar">No Contesta</span>
                     </div>
                </div>
            </div>
          </div>
        <div className="w-full mt-8">
            <label className="text-[0.85rem]" >Remitir Turno a</label>
                <select id="area" name="area" value={profesional || 0} onChange={(e) => setProfesional(Number(e.target.value))} 
                        className={`${validar && profesional === 0 && consult==='SI' ? `border-red-500 focus:border-red-500 focus:red-500`: ""}`}>
                   <option value={0} disabled>
                      Seleccionar una Profesional...
                   </option>
                      {tbMedicos.map((item, index) => {
                            return (
                                <option key={index} value={item.MedicoId}>
                                            {item.NombreUsr}
                                </option>
                              );
                        })}
               </select>
               {validar && profesional === 0 && consult==='SI' ? (
                <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                  * Campo Obligatorio.
                </p>
              ) : (
                ""
              )}
          </div>      
        </div>
      </Modal>
    </>
  );
}
LlamarModal.propTypes = {
  show: PropTypes.bool.isRequired,
  areaId: PropTypes.number.isRequired, 
  servicioId: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
};

export default LlamarModal;
